/**
 * @generated SignedSource<<0e053e4193cb7bf39a3d836baaa71283>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type adminDashboard_ImpersonateMutation$variables = {
  id: string;
};
export type adminDashboard_ImpersonateMutation$data = {
  readonly adminUserImpersonate: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly token: string | null | undefined;
  } | null | undefined;
};
export type adminDashboard_ImpersonateMutation = {
  response: adminDashboard_ImpersonateMutation$data;
  variables: adminDashboard_ImpersonateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "token",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "adminDashboard_ImpersonateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminUserImpersonateMutationPayload",
        "kind": "LinkedField",
        "name": "adminUserImpersonate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "adminDashboard_ImpersonateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AdminUserImpersonateMutationPayload",
        "kind": "LinkedField",
        "name": "adminUserImpersonate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9335ea103f05ae3d6afcb61465ae0b77",
    "id": null,
    "metadata": {},
    "name": "adminDashboard_ImpersonateMutation",
    "operationKind": "mutation",
    "text": "mutation adminDashboard_ImpersonateMutation(\n  $id: ID!\n) {\n  adminUserImpersonate(userId: $id) {\n    token\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9dd1d6c27f52ef0823d563a542ded68";

export default node;
